import { createFileRoute } from '@tanstack/react-router';
import { HelpTopicPage } from '@/features/help/pages/help-topic-page';

export const Route = createFileRoute('/_app/help/$topic')({ component: HelpTopicRoute });

function HelpTopicRoute() {
  const { topic } = Route.useParams();
  return <HelpTopicPage slug={topic} />;
}
